module.exports = new __parcel__URL__("hud_battle_royale_ready_up_button.de7bda64.png").toString();